import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import AGREGAR_CONTRATO_RESPONSABLE from '@/graphql/mutations/administracion/contratos/contrato/responsables/agregarContratoResponsable.gql';
import REMOVER_CONTRATO_RESPONSABLE from '@/graphql/mutations/administracion/contratos/contrato/responsables/removerContratoResponsable.gql';
import CONTRATO_RESPONSABLES from '@/graphql/querys/administracion/contratos/responsables/contratoResponsables.gql';

export default {
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
    contratoResponsables: {
      query: CONTRATO_RESPONSABLES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    async mixAgregarContratoResponsable() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: AGREGAR_CONTRATO_RESPONSABLE,
        variables: {
          responsable: this.responsableContrato,
        },
        update: (store, { data: { agregarContratoResponsable } }) => {
          const query = {
            query: CONTRATO_RESPONSABLES,
            variables: {
              idContrato: this.idContrato,
            },
          };
          const { contratoResponsables } = store.readQuery(query);
          const contratoResponsablesCopia = contratoResponsables.slice();
          contratoResponsablesCopia.push(agregarContratoResponsable);
          store.writeQuery({
            ...query,
            data: {
              contratoResponsables: contratoResponsablesCopia,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarContratoResponsable() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_RESPONSABLE,
        variables: {
          id: this.responsableContratoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_RESPONSABLES,
            variables: {
              idContrato: this.responsableContratoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoResponsables } = data;
          const index = contratoResponsables
            .findIndex((responsable) => responsable.id === this.responsableContratoEliminar.id);
          if (index !== -1) {
            contratoResponsables.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
